import { ThreatsBreakdownWebComponent } from './component/ThreatsBreakdownWebComponent';
import { WEB_COMPONENT_WIDGET_THREATS_BREAKDOWN } from '../webcomponents.constants';

export { ThreatsBreakdownWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_THREATS_BREAKDOWN, ThreatsBreakdownWebComponent);
